window.chartGesamtvermoegen = {
    init: function() {
        this.chart = new Highcharts.Chart('chart_gesamtvermoegen',{
            chart: {
                type: 'column',
            },
        
            xAxis: {
                visible: false,
            },

            yAxis: {
                visible: false,
            },

            tooltip: {
                enabled: false,
            },
            
            plotOptions: {
                column: {
                    stacking: undefined,
                    pointPadding: -0.1,
                    borderWidth: 0,
                    borderRadius: 8,
                },
            },

            series: this.chartdata()
        });
    },

    update: function() {
        if ( typeof this.chart !== 'undefined' ) {
            this.chartdata().forEach(function(serie) {
                this.chart.get(serie.id).setData(serie.data, false);
            }.bind(this));

            this.chart.redraw({duration: chartAnimationDuration});
        }
    },

    chartdata: () => {
        const   betragBruttovermoegen   = make_f(document.querySelector('.bruttovermoegen .betrag').innerHTML, 0),
                betragVerbindlichkeiten = make_f(document.querySelector('.verbindlichkeiten .betrag').innerHTML, 0)

        return [{
                    id:             'bruttovermoegen',
                    legendName:     'Bruttovermögen',
                    color:          farbeBruttovermoegen,
                    data:           [betragBruttovermoegen],
                },{
                    id:             'verbindlichkeiten',
                    legendName:     'Verbindlichkeiten',
                    color:          farbeVerbindlichkeiten,
                    opacity:        0.85,
                    data:           [Math.abs(betragVerbindlichkeiten)]
                }]
    }
}
